import type { Components, Theme } from '@mui/material';

export const MuiTypography = (baseTheme: Theme): Partial<Components> => {
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          '&a': {
            textDecoration: 'underline',
            color: baseTheme.palette.brand.main,
          },
        },
      },
      defaultProps: {
        variant: 'body_regular',
        variantMapping: {
          h1_deprecated: 'h1',
          h2_deprecated: 'h2',
          h3_deprecated: 'h3',
          h4_deprecated: 'h4',
          h5_deprecated: 'h5',
          body1_deprecated: 'p',

          header1_medium: 'h1',
          body_italic: 'p',
          body_medium: 'p',
          body_regular: 'p',
        },
      },
    },
  };
};
